import { ATTACHMENT_FILE_ROUTE } from "@Helpers/urlHelpers";

/*
 * These three used to prefer a `backendUrl` / `imageUrl` / `streamServerUrl` key off the redux
 * state, read through `_.get(state, "…")`. No reducer has ever contributed those keys — the fields
 * exist on the `portals` document, not in the store — so every one of those reads was `undefined`
 * and the build-time environment variable was always what came back. The dead half is gone; the
 * environment lookup and its origin-relative fallback are unchanged.
 */

export const getBackendUrl = () => {
  if (!process.env.REACT_APP_CUBE_BACKEND) {
    return `${window.location.origin}/api-server`;
  }
  return process.env.REACT_APP_CUBE_BACKEND;
};

// The one place this URL is built, on web and — through the `@Utils` alias — on mobile too. It streams
// the file's own bytes under its recorded MIME type, so it drops straight into an `<img src>` or a link
// href; see "File uploads and downloads" in packages/web/src/features/forms/CLAUDE.md.
// `awsKey` is optional on the file-entry shape and several render sites read it unguarded, so the
// parameter stays wide rather than pushing a narrowing guard onto every call site.
export const attachmentFileUrl = (awsKey: string | undefined): string =>
  `${getBackendUrl()}${ATTACHMENT_FILE_ROUTE}/${awsKey}`;

export const getImageUrl = () => {
  if (!process.env.REACT_APP_IMAGES_PUBLIC_URL) {
    return `${window.location.origin}/assets/images`;
  }
  return process.env.REACT_APP_IMAGES_PUBLIC_URL;
};

export const getStreamServerUrl = () => {
  if (!process.env.REACT_APP_STREAMING_SERVER_PATH) {
    return `wss://${window.location.host}/stream-server`;
  }
  return process.env.REACT_APP_STREAMING_SERVER_PATH;
};

// `showSupport` is widened with `| undefined` because every caller hands over the whole
// `portalData` slice, whose server-inferred `showSupport` is `boolean | undefined`.
export const shouldShowSupport = (portalData?: { showSupport?: boolean | undefined } | null): boolean =>
  Boolean(portalData?.showSupport);

export const getSupportContactHref = (): string => `mailto:${process.env.REACT_APP_CUBE_SUPPORT_EMAIL}`;
